import LoginForm from './LoginFormContainer';

export default LoginForm;
